import axios from "axios";

export default {
  data() {
    return {};
  },
  methods: {
    allowedDates(val) {
      return this.$store.state.availablePickerMarketsDates.includes(val);
    },
    pickerUpdate: async function(val) {
      //   console.log(`lookup ${val} to see if we've already fetched otherwise fetch`);
      const year = parseInt(val.split("-")[0]);

      if (!this.$store.state.fetchedPickerMarketYears.includes(year)) {
        const res = await axios
          .get(`/wisdom-markets/v1/markets/`, {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`
            },
            params: {
              from: `${year}-01-01`,
              to: `${year}-12-31`
            }
          })
          .then(response => {
            const dates = response.data.map(m => m.market_date);

            this.$store.commit("updatePickerAvailableMarketsDates", {
              dates,
              year
            });
          });
      }

      this.allowedDates();
    }
  }
};
